import { render } from "./document-details.vue?vue&type=template&id=6068eab1&ts=true&lang=pug"
import script from "./document-details.vue?vue&type=script&lang=ts"
export * from "./document-details.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__